import actions from './user-task.actions'

export default {
  actions
}
